import { render, staticRenderFns } from "./addedit.vue?vue&type=template&id=3db1c112&"
import script from "./addedit.vue?vue&type=script&lang=js&"
export * from "./addedit.vue?vue&type=script&lang=js&"
import style0 from "./addedit.vue?vue&type=style&index=0&id=3db1c112&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports